/** Default composer placeholder on Ask. */
export const ASK_PLACEHOLDER = 'Ask RCM Library about healthcare...';
